import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import ContactSection from './components/ContactSection/contact';
import ChatWidget from './components/ChatWidget/ChatWidget';


function App() {
  return (
    <Router>
      <Navbar />
      <ContactSection />
      <ChatWidget />
    </Router>
  );
}

export default App;